import { Paragraph } from 'hui';
import debounce from 'lodash/debounce';
import once from 'lodash/once';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import Constants from '../../../constants/Articles';
import { easeLoad, loadScript, registerPinterestTracking } from '../utils';
import WidgetHtmlParser from './WidgetHtmlParser';

const SnippetContainer = styled.div`
  margin-top: 3rem;
  padding: 1rem;
  border-radius: ${props => props.theme.radius.container};
  background-color: ${props => props.theme.colors.tint5};
`;

export const ArticleStyle = styled(Paragraph)`
  h2,
  .title {
    font-weight: normal;
    font-size: 32px;
    line-height: 38px;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      font-size: 36px;
      line-height: 40px;
    }
    color: ${props => props.theme.colors.tint0};
    margin-bottom: 12px;
    margin-top: 0;
    padding-top: 20px;
    padding-bottom: 5px;
  }
  img {
    width: 100%;
    height: auto;
  }

  a:not([class]) {
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
  }
`;

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  const html = document.documentElement;
  const topSlack = rect.height * 2.5;
  return (
    rect.top >= -topSlack &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight + topSlack || html.clientHeight + topSlack) &&
    rect.right <= (window.innerWidth || html.clientWidth)
  );
}

const initPinterest = once(() => {
  const attributes = {
    'data-pin-tall': true,
    'data-pin-hover': true
  };

  loadScript(Constants.PINTEREST_URL, true, attributes);
  registerPinterestTracking();
});

export default class ArticleBody extends Component<any, any> {
  static propTypes = {
    body: PropTypes.string,
    snippet: PropTypes.string
  };

  componentDidMount() {
    lazyLoadImages();
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('scroll', lazyLoadImages);
      initPinterest();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', lazyLoadImages);
  }

  render() {
    const { body, snippet } = this.props;
    return (
      <ArticleStyle tag="div">
        {snippet && (
          <SnippetContainer>
            <WidgetHtmlParser content={snippet} />
          </SnippetContainer>
        )}
        <WidgetHtmlParser content={body} />
      </ArticleStyle>
    );
  }
}

const lazyLoadImages = debounce(() => {
  if (typeof document === 'undefined' || !document) {
    return;
  }
  const images = document.querySelectorAll('img[data-srcset]');
  Array.from(images).forEach(img => {
    if (isInViewport(img)) {
      easeLoad(img);
    }
  });
}, 50);
